module.exports = __webpack_public_path__ + "static/img/uploadIcon.b61b4493.png";